module.exports = __webpack_public_path__ + "static/logo-63aec273ac0dc88dacc52c4c25efe908.png";